<template>
  <div class="show-user fl">
    <div class="user ccui-clearfix">
      <img :src="headLogo" class="user-head mr15" />
      <div>
        <template v-if="loginInfo.name">
          <div class="user-type-welcome">您好，{{ loginInfo.name }}</div>
          <!-- <el-link type="primary" @click="handleExit"
            >退出<i class="icon-ccui-next"></i
          ></el-link> -->
          <button class="btn3" @click="handleExit">退出登录</button>
        </template>
        <template v-else>
          <div class="user-type-welcome">欢迎来到交融网</div>
          <div>
            <button class="btn1" @click="handleLogin">登录</button>
            <button class="btn2" @click="handleRegister">注册</button>
          </div>
          <!-- <a class="user-type-link" @click="handleLogin"
            >请登录<i class="icon-ccui-next"></i
          ></a> -->
        </template>
      </div>
    </div>
    <div class="userimg ccui-clearfix">
      <div class="userimg-item clearfix-item">
        <!-- require('@/config/assets/images/zjsl.png') -->
        <a @click="handleHelp(1, imgOptionsA[0].targetUrl)">
          <img
            class="fl"
            src="@/config/assets/images/dianzitoubiao.png"
            style="width: 30px;height: 30px;"
          />
          <span style="font-size:12px">电子投标</span>
        </a>
        <a @click="handleHelp(2, imgOptionsB[0].targetUrl)">
          <img
            class="fl"
            src="@/config/assets/images/dianzibaojia.png"
            style="width: 30px;height: 30px;"
          />
          <span>电子报价</span>
        </a>
        <a @click="handleHelp(3, imgOptionsB[0].targetUrl)">
          <img
            class="fl"
            src="@/config/assets/images/dianzijingjia.png"
            style="width: 30px;height: 30px;"
          />
          <span>电子竞价</span>
        </a>
      </div>
      <div class="userimg-item clearfix-item">
        <!-- require('@/config/assets/images/zjfl.png') -->
        <a @click="handleHelp(4, imgOptionsB[0].targetUrl)">
          <img
            class="fl"
            src="@/config/assets/images/caozuozhinan.png"
            style="width: 30px;height: 30px;"
          />
          <span>操作指南</span>
        </a>
        <a @click="handleHelp(5, imgOptionsB[0].targetUrl)">
          <img
            class="fl"
            src="@/config/assets/images/changjianwenti.png"
            style="width: 30px;height: 30px;"
          />
          <span>常见问题</span>
        </a>
        <a @click="handleHelp(6, imgOptionsB[0].targetUrl)">
          <img
            class="fl"
            src="@/config/assets/images/zhaohuimima.png"
            style="width: 30px;height: 30px;"
          />
          <span>找回密码</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
// import { queryPublishedNoticeList } from "@/app/shop/api/shopping";
import Cookies from "js-cookie";
import { queryLscpPortalList } from "@/app/shop/api/shopping";

// import moment from "moment";
export default {
  name: "showUser",
  props: {
    imgData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dividerList: [],
      baseUrl: this.$addUrlPerFix(process.env.VUE_APP_BASE_URL),
      purchaseAgentId: "",
      supplyAgentId: "",
      imgOptionsA: [],
      imgOptionsB: []
    };
  },
  mounted() {},
  activated() {
    this.init();
  },
  deactivated() {
    this.dividerList = [];
  },
  methods: {
    init() {
      // 查询中交商旅
      queryLscpPortalList({
        columnType: 4,
        isShowPageLoading: true
      }).then(res => {
        if (res.data.code === "0") {
          this.imgOptionsA = res.data.data;
          // this.imgOptionsB =
          //   res.data.data.qryPostersListRspListBO[1].publicityContentBOS;
        }
      });
      // 查询中交福利
      queryLscpPortalList({
        columnType: 5,
        isShowPageLoading: true
      }).then(res => {
        if (res.data.code === "0") {
          this.imgOptionsB = res.data.data;
        }
      });
    },
    handleOp(row) {
      //通知公告
      let routeUrl = this.$router.resolve({
        path: "/announcementDetail",
        query: {
          id: row.noticeInfoId
        }
      });
      window.open(routeUrl.href, "_blank");
    },
    handleHelp(index, targetUrl) {
      if (index == 1) {
        window.open(
          `${this.$addUrlPerFix(
            process.env.VUE_APP_CRMA_URL
          )}/bid/homePage?a=` + sessionStorage.getItem("param_a"),
          "_blank"
        );
      } else if (index == 2) {
        let url = `${this.$addUrlPerFix(process.env.VUE_APP_EBS_URL)}`;
        this.$store.state.user.appList.forEach(item => {
          if (item.agentName == "电子报价") {
            url = item.url;
          }
        });
        window.open(url, "_blank");
      } else if (index == 3) {
        return;
      } else if (index == 4) {
        window.open(
          `${this.$addUrlPerFix(
            process.env.VUE_APP_SP_URL
          )}/operationManual?isJRZL=1`,
          "_blank"
        );
      } else if (index == 5) {
        window.open(
          `${this.$addUrlPerFix(process.env.VUE_APP_SP_URL)}/question?isJRZL=1`,
          "_blank"
        );
      } else {
        window.open(
          `${this.$addUrlPerFix(
            process.env.VUE_APP_SP_URL
          )}/retrievePassword?isJRZL=1`,
          "_blank"
        );
      }
    },
    //退出
    handleExit() {
      localStorage.clear();
      window.location.href =
        this.$addUrlPerFix("mla.iccec.cn/apis/mla/users/signup/doLogout") +
        "?ACCESS_TOKEN=" +
        Cookies.get("access_token") +
        "&redirectUrl=" +
        encodeURIComponent(window.location.href);
    },
    //登录
    handleLogin() {
      window.location.href =
        this.$addUrlPerFix(process.env.VUE_APP_LOGIN) +
        "?redirectUrl=" +
        this.$addUrlPerFix(process.env.VUE_APP_BASE_URL);
    },
    // 新用户注册
    handleRegister() {
      // 跳转注册页面
      window.open(`${this.$addUrlPerFix(process.env.VUE_APP_SRA_URL)}`);
    }
  },
  computed: {
    loginInfo() {
      return this.$store.getters.getLoginInfo;
    },
    headLogo() {
      if (this.loginInfo.iConLink) {
        return this.loginInfo.iConLink;
      } else {
        return require("@/basa/assets/images/logOn.png");
      }
    }
  }
};
</script>

<style scoped lang="scss">
.clearfix-item {
  display: flex;
  background: #ffffff;
}
.show-user {
  width: 260px;
  height: 370px;
  .user {
    width: 260px;
    height: 160px;
    margin-bottom: 10px;
    background: #ffffff;
    .user-head {
      width: 52px;
      height: 52px;
      display: block;
      margin: auto;
      padding: 19px 103px 5px 103px;
    }
    .user-type-welcome {
      // height: 28px;
      // font-family: PingFang-SC-Medium;
      // font-size: 20px;
      // color: #4a4a4a;
      // letter-spacing: 0;
      // font-weight: 500;
      width: 117px;
      height: 18px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 13px;
      color: #4a4a4a;
      line-height: 18px;
      text-align: center;
      margin: auto;
      font-style: normal;
      margin-bottom: 12px;
    }
    .btn1 {
      cursor: pointer;
      margin-left: 16px;
      margin-right: 10px;
      width: 109px;
      height: 32px;
      border-radius: 4px;
      background: #ffffff;
      color: #0089ef;
      border: 1px solid #0089ef;
      font-size: 13px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
    }
    .btn2 {
      cursor: pointer;
      width: 109px;
      height: 32px;
      background: #0089ef;
      border-radius: 4px;
      font-size: 13px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      border: 1px solid #0089ef;
      color: #ffffff;
    }
    .btn3 {
      width: 109px;
      height: 32px;
      border: 1px solid #0089ef;
      border-radius: 4px;
      margin-left: 78px;
      background: #ffffff;
      font-size: 13px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: #0089ef;
    }
    .user-type-link {
      height: 18px;
      font-family: PingFangSC-Regular;
      font-size: 13px;
      color: #4a4a4a;
      letter-spacing: 0;
      font-weight: 400;
    }
  }
  .userimg {
    width: 260px;
    height: 200px;
    background: #ffffff;
    padding: 0 30px;
    box-sizing: border-box;

    .userimg-item {
      margin-top: 30px;
      span {
        font-size: 12px;
        color: #4a4a4a;
        margin-top: 10px;
      }
      a {
        display: flex;
        flex-direction: column;
        align-items: center;
      }
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }
  }
}
.divider-header {
  padding: 10px 0 16px 0;
  font-size: 12px;
  line-height: 18px;
  .titleIcon {
    display: inline-block;
    .icon-ccui-bell-o {
      margin-right: 5px;
      color: #ff954e;
    }
    .icon-ccui-bell-o + span {
      color: #4a4a4a;
    }
  }
  .titleIcon + a {
    color: #9b9b9b;
  }
}
.dividerList {
  width: 240px;
  font-size: 13px;
  color: #4a4a4a;
  letter-spacing: 0;
  font-weight: 400;
  li {
    line-height: 18px;
    font-weight: 400;
    margin-bottom: 4px;
  }
}

.fl {
  float: left;
}
.icon-trumpet {
  width: 15.02px;
  height: 14px;
  padding-right: 7px;
}

.help-center-img {
  margin: 0 8px 10px;
}
</style>
